import { useEventsIndexContext } from 'hb-react/shared/apps/Events/contexts/EventsIndexContext';
import Grid from 'hb-react/shared/components/DesignSystem/Grid';

import EventCard from './components/EventCard';
import EventCardLoading from './components/EventCardLoading';
import EventsCards from './components/EventsCards';
import { colWidthBreakpoints, perPageBreakpoints } from './utils';

const EventsIndexContainer = ({
  groups,
  onClearFilters,
  timezoneConfiguration,
}) => {
  const { isMapDisplayed } = useEventsIndexContext();

  if (!groups) {
    return null;
  }

  return (
    <Grid mx={0}>
      {groups.map((g, index) => (
        <EventsCards
          index={index}
          name={g.name}
          noResultsMessage={g.noResultsMessage}
          resultsFoundMessage={g.resultsFoundMessage}
          params={g.params}
          singleLine={g.singleLine}
          showIfEmpty={g.showIfEmpty}
          prefetchPages={g.prefetchPages}
          onClearFilters={onClearFilters}
          key={g.name}
          colWidthBreakpoints={colWidthBreakpoints({ isMapDisplayed })}
          perPageBreakpoints={perPageBreakpoints({
            isMapDisplayed,
            singleLine: g.singleLine,
          })}
          maxPerPage={g.singleLine ? 4 : 9}
          fetchPath={g.routes.events_path}
          ItemComponent={(item) => (
            <EventCard
              {...item}
              timezoneConfiguration={timezoneConfiguration}
            />
          )}
          ItemLoadingComponent={EventCardLoading}
        />
      ))}
    </Grid>
  );
};

export default EventsIndexContainer;
